import React, { useEffect } from 'react';
import vosIcon from '../assects/Mobile_splash_screen_logo.svg';

interface Props {
  onDone: () => void;
}

const SplashScreen: React.FC<Props> = ({ onDone }) => {
  useEffect(() => {
    // Remove the inline HTML splash immediately - React splash takes over
    const htmlSplash = document.getElementById('html-splash');
    if (htmlSplash) {
      htmlSplash.style.opacity = '0';
      setTimeout(() => htmlSplash.remove(), 260);
    }
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(0.85); }
          50% { opacity: 1; transform: scale(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes logoReveal {
          from { opacity: 0; transform: scale(0.88); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

      <div style={{
        position: 'fixed',
        inset: 0,
        background: '#3b1f52',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          animation: 'logoReveal 0.6s cubic-bezier(0.22,1,0.36,1) both',
        }}>
          <img
            src={vosIcon}
            alt="VAV School"
            style={{
              width: 180,
              height: 180,
              objectFit: 'contain',
            }}
          />
        </div>
        {/* Title & subtitle */}
        <div
          style={{
            textAlign: 'center',
            animation: 'vav-text-in 0.55s ease 0.42s both',
          }}
        >
          {/* <h1
            style={{
              color: '#fff',
              fontSize: '1.4rem',
              fontWeight: 700,
              margin: '0 0 10px',
              letterSpacing: '-0.025em',
              lineHeight: 1.15,
            }}
          >
           VAV School
          </h1> */}
          {/* <p
            style={{
              color: 'rgba(255,255,255,0.72)',
              fontSize: '0.975rem',
              margin: '0 0 52px',
              fontWeight: 400,
            }}
          >
            Managed by VNEW Trust &middot; Ranchi, Jharkhand
          </p> */}
        </div>

        {/* Loading dots */}
        <div style={{
          position: 'absolute',
          bottom: 56,
          display: 'flex',
          gap: 8,
          animation: 'fadeIn 0.5s ease 1s both',
        }}>
          {[0, 1, 2].map(i => (
            <div
              key={i}
              style={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.45)',
                animation: `pulse 1.4s ease ${i * 0.22}s infinite`,
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SplashScreen;